export default __webpack_public_path__ + "static/media/book-two.950e3286.png";